import React from 'react';
import ComradeQuestions from './ComradeQuestions'

class Body extends React.Component {
    
    render() {
        return (
            <div>
                <ComradeQuestions />
            </div>

        );
    }
}



export default Body;